module.exports = __webpack_public_path__ + "static/01_alex_munteanu-11b1f1514b1cbc167c2c29da87a3ee7c.jpg";